module.exports = __webpack_public_path__ + "static/wind-alert-cover-fa66ccb6d018ece30a638025d7e0413b.jpg";